var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useState } from 'react';
import { Typography } from '@mui/material';
import GridBase from '../../../components/grid_base';
import BotoesExportacao from '../../../components/botoes_exportacao';
import { FiltrosAtendimentos } from '../components/FiltrosAtendimentos';
import { ROUTES, FUNCIONALIDADES, PAGINAS } from '../../../routes';
import { useAuth } from '../../../contexts/auth/AuthContext';
import * as service from './atendimentos_insercao_laboral.service';
var COLUNAS = [
    { field: 'id', headerName: 'Matrícula', width: 130 },
    { field: 'reeducando', headerName: 'Colaborador', width: 250, valueGetter: function (_value, row) { var _a; return (_a = row.reeducando) === null || _a === void 0 ? void 0 : _a.nome; } },
    { field: 'atendente', headerName: 'Atendente', width: 250, valueGetter: function (_value, row) { var _a; return (_a = row.atendente) === null || _a === void 0 ? void 0 : _a.nome; } },
    { field: 'quantidade', headerName: 'Qtd. Solicitada', width: 150 },
    { field: 'situacao', headerName: 'Situação', width: 150 },
];
export var AtendimentosInsercaoLaboralListar = function () {
    var _a = useState(0), valorTotalizador = _a[0], setValorTotalizador = _a[1];
    var _b = useAuth(), User = _b.User, getAcoesFuncionalidade = _b.getAcoesFuncionalidade;
    var obterAtendenteEfetivo = function (atendenteFiltro) {
        var acoesAdmin = getAcoesFuncionalidade(FUNCIONALIDADES.ATENDIMENTOS_ADMIN);
        var eAtendenteAdmin = !!(acoesAdmin === null || acoesAdmin === void 0 ? void 0 : acoesAdmin['VISUALIZAR']);
        if (eAtendenteAdmin) {
            return atendenteFiltro === -1 ? null : atendenteFiltro.toString();
        }
        return (User === null || User === void 0 ? void 0 : User.id) ? User.id.toString() : null;
    };
    return (_jsxs(_Fragment, { children: [_jsx(GridBase, { pagina: PAGINAS.ATENDIMENTOS_INSERCAO_LABORAL, paginaPermissao: FUNCIONALIDADES.ATENDIMENTOS_INSERCAO_LABORAL, rota: ROUTES.ATENDIMENTOS_INSERCAO_LABORAL, columns: COLUNAS, filtrosIniciais: {
                    situacao: '-1',
                    atendente: -1,
                    dataInicio: '',
                    dataFim: '',
                }, fetchData: function (textoBusca, filtros, paginationModel) { return __awaiter(void 0, void 0, void 0, function () {
                    var atendenteParam, resposta, total_1;
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0:
                                atendenteParam = obterAtendenteEfetivo(filtros.atendente);
                                return [4 /*yield*/, service.getAtendimentos(textoBusca === '' ? null : textoBusca, filtros.situacao === '-1' ? null : filtros.situacao, atendenteParam, filtros.dataInicio === '' ? null : filtros.dataInicio, filtros.dataFim === '' ? null : filtros.dataFim, paginationModel)];
                            case 1:
                                resposta = _a.sent();
                                if (resposta && 'dados' in resposta && Array.isArray(resposta.dados)) {
                                    total_1 = 0;
                                    resposta.dados.forEach(function (item) {
                                        total_1 += item.quantidade || 0;
                                    });
                                    setValorTotalizador(total_1);
                                }
                                return [2 /*return*/, resposta];
                        }
                    });
                }); }, renderFiltros: function (filtros, atualizarFiltros) { return (_jsx(FiltrosAtendimentos, { filtros: filtros, atualizarFiltros: atualizarFiltros, getCombosListar: service.getCombosListar })); }, botoesSuperiorExtras: function (estadoBusca, acoesPermitidas) {
                    var estadoAdaptado = __assign(__assign({}, estadoBusca), { status: estadoBusca.situacao, instituicao: obterAtendenteEfetivo(estadoBusca.atendente) });
                    return (_jsx(BotoesExportacao, { estadoBusca: estadoAdaptado, acoesPermitidas: acoesPermitidas, gerarPDF: service.gerarPDFAtendimentos, gerarExcel: service.gerarExcelAtendimentos, nomeArquivo: 'atendimentos' }));
                } }), _jsx(Typography, __assign({ variant: 'body1', sx: { color: 'text.secondary', mt: 2, ml: 2 } }, { children: "*Totalizador de atendimentos : ".concat(valorTotalizador) }))] }));
};
export default AtendimentosInsercaoLaboralListar;
